export function toLocaleISOString() {
  var date = new Date()
  var offset = date.getTimezoneOffset()
  date = new Date(date.getTime() - offset * 60 * 1000)
  return date.toISOString().slice(0, 19)
}
